// const log = global.log.getLogger("f_mtac.ui.ConfirmationArea");
const LoadingArea = function () {
    var {Modal} = window.f_mtac_theme;
    var loading_area_modal;

    let interaction_end = () => {
        loading_area_modal.hide();
        $("body").off("click.loading_area.btn", "#loading_area .btn");
    };
    this.interaction = null;
    this.interact = function ({title = "", tip1 = "", tip2 = ""}) {
        loading_area_modal = new Modal(document.getElementById("loading_area"), {
            backdrop: "static", // avoid closing window when clicking outside
            keyboard: false
        });
        $("#loading_area .modal-title").html(title);
        $("#loading_area p.tip1").html(tip1); // AGPOC-4659: use .html() for special characters
        $("#loading_area p.tip2").html(tip2);
        return new Promise((resolve) => {
            let handlers = {
                close: () => {
                    resolve();
                    interaction_end();
                    this.interaction = null;
                }
            };
            loading_area_modal.show();
            $("body").on("click.loading_area.btn", "#loading_area .btn", (event) => {
                handlers[$(event.currentTarget).data("method")]();
            });
            this.interaction = {
                close: () => {
                    resolve();
                    interaction_end();
                    this.interaction = null;
                }
            };
        });
    };
};
export default new LoadingArea();
